import useTranslation from 'next-translate/useTranslation';
import { List, ListItem, StyledLink } from './styles';
import TransText from 'next-translate/TransText';

export default function TermsContent() {
  const { t } = useTranslation('refer');

  return (
    <List>
      {Array.from({ length: 5 }).map((_, i) => (
        <ListItem key={`refer_terms_item_${i}`}>
          <TransText
            components={[<StyledLink key="terms_content_key" href="/bonus" />]}
            text={t(`refer_terms.${i + 1}`, {
              app_provider: process.env.NEXT_PUBLIC_BET_NAME,
            })}
          />
        </ListItem>
      ))}
    </List>
  );
}
